import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../components/Home';
import Product from '../components/Product';
Vue.use(VueRouter);

export default new VueRouter({
    
    routes: [
        { 
            path: '/',
            redirect: '/home'
        },
        {   
            path: '/home',
            name: 'home',
            component: Home 
        },
        {   
            path: '/product/:id',
            name: 'product',
            component: Product 
        }
    ]
})